// The exported code uses Tailwind CSS. Install Tailwind CSS in your dev environment to ensure all styles work.

import React, { useEffect, useRef, useState } from 'react';
import EnlishNewDrone from "./EnlishNewDrone";
import Navbar from '../homepage/Navbar';
import {Footer} from "../../shared";

const DronePlanetLanding = () => {
    const newDroneRef = useRef(null);
const scrollToNewDroneSection = () => {
  newDroneRef.current?.scrollIntoView({ behavior: "smooth" });
};
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };
useEffect(() => {
  window.scrollTo({ top: 0, behavior: 'smooth' });
}, []);
  return (
    <>
    < Navbar />
    <div className="min-h-screen bg-gray-50 text-gray-800">
    
      {/* Hero Section */}
      <section className="relative pt-24 min-h-[700px] flex items-center overflow-hidden">
        <div 
          className="absolute inset-0 z-0" 
          style={{
            backgroundImage: "url('https://readdy.ai/api/search-image?query=Professional%20aerial%20drone%20flying%20in%20a%20dramatic%20sky%20with%20blue%20and%20orange%20sunset%20colors%2C%20high-tech%20futuristic%20drone%20with%20LED%20lights%2C%20cinematic%20wide%20angle%20shot%2C%20photorealistic%2C%20high%20resolution%2C%20showing%20advanced%20technology%20in%20flight%2C%20perfect%20for%20tech%20company%20website%20hero%20image&width=1440&height=700&seq=1&orientation=landscape')",
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
            filter: 'brightness(0.7)'
          }}
        ></div>
        <div className="container mx-auto px-4 z-10 relative">
          <div className="max-w-2xl text-white bg-gradient-to-r from-blue-900/80 to-transparent p-8 rounded-lg backdrop-blur-sm">
            <h1 className="text-4xl md:text-5xl font-bold mb-4">Welcome to DronePlanet – Where Innovation Takes Flight!</h1>
            <h2 className="text-xl md:text-2xl mb-6">Are You a Drone Manufacturer? Stop Waiting. Start Selling. Start Hiring.</h2>
            <p className="text-lg mb-8">Join the #1 Explosive Marketplace for Drones, Parts & Talents.</p>
                <button
        onClick={scrollToNewDroneSection}
        className="px-6 py-3 bg-orange-500 text-white rounded-xl text-base font-medium hover:bg-orange-600 transition-all shadow-md flex items-center gap-2"
      >
        Register as a Vendor
        <i className="fas fa-arrow-right"></i>
      </button>

          </div>
        </div>
      </section>

      {/* Value Proposition Banner */}
      <section className="bg-blue-600 text-white py-8">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="flex items-center space-x-4">
              <div className="text-4xl text-orange-400">
                <i className="fas fa-store"></i>
              </div>
              <div>
                <h3 className="text-xl font-bold">Sell Directly to Thousands</h3>
                <p>Connect with ready-to-buy drone enthusiasts</p>
              </div>
            </div>
            <div className="flex items-center space-x-4">
              <div className="text-4xl text-orange-400">
                <i className="fas fa-tag"></i>
              </div>
              <div>
                <h3 className="text-xl font-bold">Showcase Your Brand</h3>
                <p>Your Drones. Your Parts. Your Prices.</p>
              </div>
            </div>
            <div className="flex items-center space-x-4">
              <div className="text-4xl text-orange-400">
                <i className="fas fa-briefcase"></i>
              </div>
              <div>
                <h3 className="text-xl font-bold">Post Job Openings</h3>
                <p>Hire Engineers, Technicians & Sales Pros FAST</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Why Register Section */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl font-bold text-center mb-12">🔥 Why Register on DronePlanet?</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            <div className="bg-blue-50 p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow">
              <div className="text-green-500 mb-4">
                <i className="fas fa-check-circle text-2xl"></i>
              </div>
              <h3 className="text-xl font-semibold mb-2">Sell Directly to Thousands</h3>
              <p>Connect with ready-to-buy drone enthusiasts who are looking for exactly what you offer.</p>
            </div>
            <div className="bg-blue-50 p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow">
              <div className="text-green-500 mb-4">
                <i className="fas fa-check-circle text-2xl"></i>
              </div>
              <h3 className="text-xl font-semibold mb-2">Showcase Your Brand</h3>
              <p>Your Drones. Your Parts. Your Prices. Complete control over your product listings.</p>
            </div>
            <div className="bg-blue-50 p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow">
              <div className="text-green-500 mb-4">
                <i className="fas fa-check-circle text-2xl"></i>
              </div>
              <h3 className="text-xl font-semibold mb-2">Post Job Openings</h3>
              <p>Hire Engineers, Technicians & Sales Pros FAST from our pool of qualified candidates.</p>
            </div>
            <div className="bg-blue-50 p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow">
              <div className="text-green-500 mb-4">
                <i className="fas fa-check-circle text-2xl"></i>
              </div>
              <h3 className="text-xl font-semibold mb-2">Get Instant Visibility</h3>
              <p>Join a platform BUILT for Drone Businesses and get noticed immediately.</p>
            </div>
          </div>
        </div>
      </section>
 
      {/* Manufacturer Focus Section */}
      <section className="py-16 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-3xl font-bold mb-6">Your Storefront. Your Rules. Your Profits.</h2>
              <p className="text-lg mb-6">You're a manufacturer – you build the future. Let the world see it.</p>
              <p className="mb-6">From cutting-edge drones to essential components, DronePlanet is where your products get the attention and orders they deserve.</p>
              <p className="text-xl font-semibold text-blue-600">No Middlemen. No Delays. Just SALES.</p>
            </div>
            <div className="rounded-lg overflow-hidden shadow-xl">
              <img 
                src="https://readdy.ai/api/search-image?query=Professional%20drone%20manufacturing%20facility%20with%20engineers%20working%20on%20high-tech%20drones%2C%20clean%20modern%20workspace%20with%20technical%20equipment%2C%20bright%20lighting%2C%20showing%20precision%20manufacturing%20process%2C%20industrial%20setting%20with%20blue%20accents%2C%20photorealistic%20high%20resolution%20image&width=600&height=400&seq=2&orientation=landscape" 
                alt="Drone Manufacturing" 
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </div>
      </section>
{/* <section
  ref={newDroneRef}
  className="w-full px-2 sm:px-4 py-0 sm:max-w-3xl md:max-w-4xl lg:max-w-7xl mx-auto"
>
  <EnlishNewDrone />
</section> */}


      {/* Talent Section */}
      <section className="py-16 bg-blue-600 text-white">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div className="order-2 lg:order-1 rounded-lg overflow-hidden shadow-xl">
              <img 
                src="https://readdy.ai/api/search-image?query=Diverse%20team%20of%20drone%20engineers%20and%20technicians%20collaborating%20in%20a%20modern%20tech%20office%2C%20working%20on%20drone%20designs%20and%20software%2C%20professional%20setting%20with%20computers%20and%20drone%20prototypes%20visible%2C%20clean%20workspace%20with%20blue%20lighting%20accents%2C%20photorealistic%20high%20resolution%20image&width=600&height=400&seq=3&orientation=landscape" 
                alt="Drone Talent" 
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="order-1 lg:order-2">
              <h2 className="text-3xl font-bold mb-6">🧠 Need Talent to Build More?</h2>
              <p className="text-lg mb-6">Post your job openings and find skilled experts in hardware, software, design, R&D, and more.</p>
              <p className="mb-6">Thousands of applicants. One platform.</p>
              <p className="text-xl font-semibold text-orange-300">Hire faster than your competition can blink.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Target Audience Section */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl font-bold text-center mb-12">Who's It For?</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5 gap-6">
            <div className="bg-blue-50 p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow text-center cursor-pointer">
              <div className="text-blue-600 mb-4">
              <i className="fas fa-plane-departure text-4xl"></i>
              </div>
              <h3 className="text-lg font-semibold">Drone & UAV Manufacturers</h3>
            </div>
            <div className="bg-blue-50 p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow text-center cursor-pointer">
              <div className="text-blue-600 mb-4">
                <i className="fas fa-microchip text-4xl"></i>
              </div>
              <h3 className="text-lg font-semibold">Drone Part & Component Makers</h3>
            </div>
            <div className="bg-blue-50 p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow text-center cursor-pointer">
              <div className="text-blue-600 mb-4">
                <i className="fas fa-tools text-4xl"></i>
              </div>
              <h3 className="text-lg font-semibold">Custom Drone Builders</h3>
            </div>
            <div className="bg-blue-50 p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow text-center cursor-pointer">
              <div className="text-blue-600 mb-4">
                <i className="fas fa-rocket text-4xl"></i>
              </div>
              <h3 className="text-lg font-semibold">Startups in Drone Tech</h3>
            </div>
            <div className="bg-blue-50 p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow text-center cursor-pointer">
              <div className="text-blue-600 mb-4">
                <i className="fas fa-plane text-4xl"></i>
              </div>
              <h3 className="text-lg font-semibold">Anyone Building the Future of Flight</h3>
            </div>
          </div>
        </div>
      </section>

      {/* Call-to-Action Section */}
    <section className="py-16 bg-gradient-to-r from-blue-700 to-blue-900 text-white">
  <div className="container mx-auto px-4 text-center">
    <h2 className="text-3xl md:text-4xl font-bold mb-6">
      ⚡ Ready to Dominate the Drone Market?
    </h2>
    <p className="text-xl mb-8 max-w-3xl mx-auto">
      Don't wait for customers. Go where they already are. DronePlanet is the hottest drone marketplace — and you belong at the center.
    </p>

    {/* Centered Button */}
    <div className="flex justify-center">
      <button
  onClick={scrollToNewDroneSection}
  className="px-6 py-3 bg-blue-600 text-white rounded-xl text-base font-medium hover:bg-blue-700 transition-all shadow-md flex items-center gap-2"
>
  Register as a Vendor <i className="fas fa-arrow-right"></i>
</button>

    </div>
  </div>
</section>

    </div>
    < Footer />
    </>
  );
};

export default DronePlanetLanding;
